export default "__VITE_ASSET__c5d919b5__"